/**
 *
 * @export
 * @interface InlineResponse20015
 */
export interface InlineResponse20015 {
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20015
   */
  success: boolean;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015
   */
  message: string;
  /**
   *
   * @type {Array<ComplexAggregation>}
   * @memberof InlineResponse20015
   */
}

export function InlineResponse20015FromJSON(json: any): InlineResponse20015 {
  return InlineResponse20015FromJSONTyped(json);
}

export function InlineResponse20015FromJSONTyped(json: any): InlineResponse20015 {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    success: json['success'],
    message: json['message'],
  };
}

export function InlineResponse20015ToJSON(value?: InlineResponse20015 | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    success: value.success,
    message: value.message,
  };
}
